<template>
    <v-card class="pa-1 d-flex justify-space-between file-info" outlined>
        <v-icon>insert_drive_file</v-icon>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <div class="subtitle-2 file-name" v-on="on">
                    {{ id ? file.name.substring(file.name.indexOf('_') + 1) : file.name }}
                </div>
            </template>
            <span>{{ id ? file.name.substring(file.name.indexOf('_') + 1) : file.name }}</span>
        </v-tooltip>
        <v-menu offset-y>
            <template v-slot:activator="{ on }">
                <v-icon v-on="on">keyboard_arrow_down</v-icon>
            </template>
            <v-list>
                <v-list-item @click="removeFile()">
                    <v-list-item-title>{{ $t('common.fileInfo.delete') }}</v-list-item-title>
                </v-list-item>
                <v-list-item text :href="file.url" :download="file.name.indexOf('_') + 1" v-if="file.url">
                    <v-list-item-title>{{ $t('common.fileInfo.download') }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-card>
</template>

<script>
export default {
    name: 'contract-file-info',
    props: ['file', 'id', 'type', 'clearFile'],
    methods: {
        async removeFile () {
            if (confirm(`${this.$t('common.fileInfo.confirm')} ${this.file.name}`)) {
                this.clearFile()
            }
        }
    }
}
</script>

<style lang="scss">
.file-info {
    .file-name {
        max-height: 1.375rem;
        overflow: hidden;
    }
}
.file-info:hover{
    background-color: #f6f8f9;
}
</style>
